import { render, staticRenderFns } from "./CreateProperty.vue?vue&type=template&id=67668a2b"
import script from "./CreateProperty.vue?vue&type=script&lang=js"
export * from "./CreateProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports